import { css, styled } from 'styled-components';

import { tk } from '@sunwebgroup/ui-components';
import { usePriceFilters } from '@/domain/prices/filters/hooks';
import type { PropsWithChildren } from 'react';

export const GridTabs = ({ children }: PropsWithChildren) => {
  const { isEmptyResponse, isError } = usePriceFilters();
  if (isEmptyResponse || isError) return null;

  return <GridTabsWrapper>{children}</GridTabsWrapper>;
};
const GridTabsWrapper = styled.div`
  width: 100%;
  border-bottom: 2px solid ${tk('color_semantic_border')};
  display: flex;
  flex-direction: row;
  overflow-x: auto;
`;

export const GridTab = styled.div<{ $selected: boolean }>`
  height: ${tk('spacing_3xl')};
  padding: ${tk('spacing_md')} ${tk('spacing_lg')};
  text-align: center;
  cursor: pointer;
  white-space: nowrap;

  ${({ $selected }) =>
    $selected &&
    css`
      border-bottom: 2px solid ${tk('color_semantic_text_subdued_hover')};
    `}
  &:hover {
    border-bottom: 2px solid ${tk('color_semantic_text_subdued_hover')};
  }
`;
